export const resources = {
  ActionableInputSaveChanges: ''
};
